
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ScrapReasonMstApi } from '../../api/master/scrap-reason-mst.api';
import { ScrapReasonMst, ScrapReasonMstData } from '../../interface/master/scrap-reason-mst';

@Injectable()
export class ScrapReasonMstService extends ScrapReasonMstData {

  constructor(private api: ScrapReasonMstApi) {
    super();
  }
  list(url: string): Observable<ScrapReasonMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<ScrapReasonMst>{
      return this.api.getById(url);
  }
  create(url: string, data:ScrapReasonMst): Observable<ScrapReasonMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:ScrapReasonMst): Observable<ScrapReasonMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
